/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WCAG AA needs 4.5:1 for normal text and 3:1 for large text. AAA needs 7:1 and 4.5:1. AA is the common legal and design baseline.`)
};

const es_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WCAG AA necesita 4.5:1 para texto normal y 3:1 para texto grande. AAA necesita 7:1 y 4.5:1. AA es el estándar legal y de diseño más común.`)
};

const de_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WCAG AA verlangt 4,5:1 für normalen Text und 3:1 für großen Text. AAA verlangt 7:1 bzw. 4,5:1. AA ist der übliche rechtliche und gestalterische Mindeststandard.`)
};

const nl_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WCAG AA vereist 4,5:1 voor normale tekst en 3:1 voor grote tekst. AAA vereist 7:1 en 4,5:1. AA is de gebruikelijke wettelijke en ontwerpbasis.`)
};

const fr_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le niveau WCAG AA exige 4,5:1 pour le texte normal et 3:1 pour le grand texte. Le niveau AAA exige 7:1 et 4,5:1. AA est la référence légale et de design courante.`)
};

const it_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il WCAG AA richiede 4,5:1 per il testo normale e 3:1 per il testo grande. L'AAA richiede 7:1 e 4,5:1. L'AA è la base comune per legge e design.`)
};

const pt_br2_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O WCAG AA exige 4,5:1 para texto normal e 3:1 para texto grande. O AAA exige 7:1 e 4,5:1. O AA é o padrão legal e de design mais comum.`)
};

const pt_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O WCAG AA exige 4,5:1 para texto normal e 3:1 para texto grande. O AAA exige 7:1 e 4,5:1. O AA é a referência legal e de design mais comum.`)
};

const ja_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WCAG AAでは通常テキストで4.5:1、大きいテキストで3:1が必要です。AAAでは7:1と4.5:1です。AAが一般的な法的・デザイン上の基準です。`)
};

const zh_cc_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WCAG AA 级要求正文文字达到 4.5:1，大号文字达到 3:1。AAA 级则要求 7:1 和 4.5:1。AA 是常见的法律和设计基准。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq_a1", locale)
	if (locale === "en") return en_cc_faq_a1(inputs)
	if (locale === "es") return es_cc_faq_a1(inputs)
	if (locale === "de") return de_cc_faq_a1(inputs)
	if (locale === "nl") return nl_cc_faq_a1(inputs)
	if (locale === "fr") return fr_cc_faq_a1(inputs)
	if (locale === "it") return it_cc_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq_a1(inputs)
	if (locale === "pt") return pt_cc_faq_a1(inputs)
	if (locale === "ja") return ja_cc_faq_a1(inputs)
	return zh_cc_faq_a1(inputs)
};